'use client';

import { ListingPayload } from '@/slw/entities/seller/listing';

export function ListingExterior({ listing }: { listing: ListingPayload }) {
  return (
    <section>
      <div className='flex flex-col font-medium text-sm '>
        <ul className='block md:flex px-4  gap-50 list-disc font-medium pt-4'>
          {listing.exteriorColor && (
            <li className='leading-[150%]'>
              <span>Exterior color: {listing.exteriorColor}</span>
            </li>
          )}
          {listing.interiorColor && (
            <li className='py-2'>
              <span className='leading-[150%]'>Interior color: {listing.interiorColor}</span>
            </li>
          )}
        </ul>
        <ul className='block md:flex px-4 flex-col gap-4 list-disc font-medium'>
          {listing.exteriorCondition && (
            <li>
              <span>Exterior condition: {listing.exteriorCondition}</span>
              {listing.exteriorConditionMoreDescription && (
                <div className='mt-4 space-y-4'>
                  <h3 className='text-lg font-semibold'>Description of exterior condition: </h3>
                  <span className='text-sm font-normal leading-[150%]'>{listing.exteriorConditionMoreDescription}</span>
                </div>
              )}
            </li>
          )}
          {listing.seatMaterial && (
            <li>
              <span>Seat material: {listing.seatMaterial}</span>
              {listing.seatMaterialOther && (
                <div className='mt-4 space-y-4'>
                  <h3 className='text-lg font-semibold'>Description of seat material:</h3>
                  <span className='text-sm font-normal leading-[150%]'>{listing.seatMaterialOther}</span>
                </div>
              )}
            </li>
          )}
        </ul>
      </div>
    </section>
  );
}
